import { useQuery } from "@tanstack/react-query";
import {
  getDcs,
  getDealerCategories,
  getGoodsGroups,
  getJobs,
  getManufacturers,
  getManufacturersList,
  getProducts,
  getTargetGroups,
  getSaleoffices,
} from "./catalog";
import { catalogQueryKeys } from "./query-keys";
import { normalizeListResponse } from "./transformers";

export function useGetProducts() {
  return useQuery({
    queryKey: catalogQueryKeys.products(),
    queryFn: getProducts,
  });
}

export function useGetManufacturers() {
  return useQuery({
    queryKey: catalogQueryKeys.manufacturers(),
    queryFn: getManufacturers,
  });
}

export function useGetManufacturersList() {
  return useQuery({
    queryKey: catalogQueryKeys.manufacturersList(),
    queryFn: getManufacturersList,
  });
}

export function useGetGoodsGroups() {
  return useQuery({
    queryKey: catalogQueryKeys.goodsGroups(),
    queryFn: getGoodsGroups,
  });
}

export function useGetJobs() {
  return useQuery({
    queryKey: catalogQueryKeys.jobs(),
    queryFn: getJobs,
    select: normalizeListResponse,
  });
}

export function useGetDcs() {
  return useQuery({
    queryKey: catalogQueryKeys.dcs(),
    queryFn: getDcs,
  });
}

export function useGetDealerCategories() {
  return useQuery({
    queryKey: catalogQueryKeys.dealerCategories(),
    queryFn: getDealerCategories,
  });
}

export function useGetTargetGroups() {
  return useQuery({
    queryKey: catalogQueryKeys.targetGroups(),
    queryFn: getTargetGroups,
    select: (data) => (Array.isArray(data) ? data : []),
  });
}

export function useGetSaleoffices() {
  return useQuery({
    queryKey: catalogQueryKeys.saleoffices(),
    queryFn: getSaleoffices,
    select: (data) => (Array.isArray(data) ? data : []),
  });
}
